import { render, staticRenderFns } from "./ModalShopping.vue?vue&type=template&id=5795aaf8&"
import script from "./ModalShopping.vue?vue&type=script&lang=js&"
export * from "./ModalShopping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports